<template>
    <div class="empty-widget">
        <div class="empty-content">
            <i class="material-icons">{{ icon }}</i>
            <div class="message">{{ message }}</div>
            <a-button type="primary" @click="$emit('edit')" v-if="!hasValidSettings">
                <i class="material-icons">settings</i>
                {{ $t('table.editSettings') }}
            </a-button>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "EmptyWidget",
    props: {
        error: {
            type: String,
            default: null,
        },
        hasValidSettings: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        icon() {
            if (this.error) return "error_outline";
            if (!this.hasValidSettings) return "settings";
            return "info_outline";
        },
        message() {
            if (this.error) return this.error;
            if (!this.hasValidSettings) return "Widget ayarları yapılandırılmamış";
            return "Widget yüklenirken bir hata oluştu";
        },
    },
});
</script>

<style scoped lang="scss">
.empty-widget {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fafafa;
    padding: 24px;

    .empty-content {
        text-align: center;

        .material-icons {
            font-size: 48px;
            color: rgba(0, 0, 0, 0.25);
            margin-bottom: 16px;
        }

        .message {
            color: rgba(0, 0, 0, 0.45);
            margin-bottom: 16px;
            font-size: 14px;
        }

        .ant-btn {
            display: inline-flex;
            align-items: center;
            gap: 8px;

            .material-icons {
                font-size: 18px;
                margin: 0;
                color: currentColor;
            }
        }
    }
}
</style> 